export enum RequestTypeEnum {
    ABSENCE = 1,
    EXPENSE_REPORT = 2,
}
